$(document).ready(function () {

   if (window.location.href.indexOf("products") > -1) {

       if (document.querySelector('input', 'button')) {

           document.querySelectorAll('input', 'button').forEach((elem) => {

               elem.addEventListener("click", function (event) {

                   console.log("Click");

                   setTimeout(function () {

                       $('#reload').load(" #reload");

                       $('#reload-savings').load(" #reload-savings");

                   }, 200);

               });

           });

       }

   }

});